import { render, staticRenderFns } from "./mod8.vue?vue&type=template&id=59851587&scoped=true&"
import script from "./mod8.vue?vue&type=script&lang=js&"
export * from "./mod8.vue?vue&type=script&lang=js&"
import style0 from "./mod8.vue?vue&type=style&index=0&id=59851587&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59851587",
  null
  
)

export default component.exports